// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__RW5CA"};